import clsx from 'clsx';
import { isoToBrDate } from '../../../utils/vacationDates';
import { formatPeriodLabel } from '../../../utils/vacationHistoryPeriods';
import { selectVisibleSegments } from '../../../utils/vacationHistoryReport';
import type { HistoryRequestRow, HistoryEventKind } from '../../../models/vacationHistoryReport.types';
import { HISTORY_CARD_LABELS, HISTORY_CARD_CLASSES } from '../vacationHistoryResultsCards.definitions';

interface HistorySegmentsBlockProps {
    row: HistoryRequestRow;
    kind: HistoryEventKind;
    periodFilterKey: string | null;
}

export function HistorySegmentsBlock({ row, kind, periodFilterKey }: HistorySegmentsBlockProps) {
    const visibleSegments = selectVisibleSegments(row, kind, periodFilterKey);

    return (
        <div className={clsx(HISTORY_CARD_CLASSES.divider, HISTORY_CARD_CLASSES.dividerVertical)}>
            <p className={HISTORY_CARD_CLASSES.label}>{HISTORY_CARD_LABELS.vacations}</p>
            <div className={HISTORY_CARD_CLASSES.segmentsList}>
                {visibleSegments.map(({ segment, order }) => {
                    const decision = row.segmentDecisions?.[String(order)];
                    const isRejected = decision?.status === 'Rejected';
                    const label = row.segments.length > 1 ? `${order}ª parcela` : '';

                    return (
                        <div key={order} className={clsx(HISTORY_CARD_CLASSES.segment, isRejected && HISTORY_CARD_CLASSES.segmentRejected)}>
                            {label && <span className={HISTORY_CARD_CLASSES.segmentLabel}>{label} · </span>}
                            <span>
                                {isoToBrDate(segment.startDate)} a {isoToBrDate(segment.endDate)}
                            </span>
                            <span className={HISTORY_CARD_CLASSES.segmentDays}> · {segment.days} dias</span>
                            {isRejected && <span className={HISTORY_CARD_CLASSES.rejectedBadge}>recusada</span>}
                        </div>
                    );
                })}
                {row.hasApprovedSell && (
                    <div className={HISTORY_CARD_CLASSES.sellInfo}>
                        {HISTORY_CARD_LABELS.withSell} · {row.sellDays} dias
                    </div>
                )}
                {row.periodAllocations && row.periodAllocations.length > 0 && (
                    <div className={HISTORY_CARD_CLASSES.acquisitionInfo}>
                        <span className={HISTORY_CARD_CLASSES.acquisitionLabel}>{HISTORY_CARD_LABELS.acquisitionPeriod} · </span>
                        {row.periodAllocations.length === 1 ? (
                            <span>
                                {formatPeriodLabel(
                                    row.periodAllocations[0].startDate,
                                    row.periodAllocations[0].endDate
                                )}
                                {row.periodAllocations[0].isAccruing && ' (em andamento)'}
                                {!row.periodAllocations[0].isAccruing && ` · gozar até ${isoToBrDate(row.periodAllocations[0].concessiveDeadline)}`}
                            </span>
                        ) : (
                            <span>
                                {row.periodAllocations
                                    .map(
                                        (alloc) =>
                                            `${alloc.days} dias do ${formatPeriodLabel(
                                                alloc.startDate,
                                                alloc.endDate
                                            )}${alloc.isAccruing ? ' (em andamento)' : ''}`
                                    )
                                    .join(' + ')}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
